// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".employee-list-qw[data-v-448d669b] {\n  height: 100%;\n}\n.qywx-name[data-v-448d669b] {\n  margin-right: 0.21333rem;\n  vertical-align: middle;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
